var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-scroll-x-reverse-transition', [_vm.displayed ? _c('div', {
    staticClass: "popup popup-form white broker-calendar-panel"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [!_vm.calendarLoading ? _c('calendar-custom', {
    attrs: {
      "calendar-events": _vm.events,
      "event-users": _vm.eventUsers
    },
    on: {
      "close": _vm.closecard,
      "event-deleted": function eventDeleted($event) {
        return _vm.deleteEvent($event);
      }
    }
  }) : _c('div', {
    staticClass: "bcg-loading"
  }, [_c('button', {
    staticClass: "calendar-loading-close",
    attrs: {
      "type": "button",
      "aria-label": "Zavrieť kalendár"
    },
    on: {
      "click": _vm.closecard
    }
  }, [_vm._v("×")]), _c('v-progress-circular', {
    staticClass: "loading-spinner",
    attrs: {
      "indeterminate": ""
    }
  })], 1)], 1)]) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }